module.exports = __webpack_public_path__ + "img/VG.ccea90f1.svg";